/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number } from 'prop-types'

const Info = ({ height = 15 }) => {
  return (
    <svg width={15} height={height} viewBox="0 0 21 21">
      <path
        data-name="Path 222"
        d="M657.452 364.9A10.452 10.452 0 10647 354.452a10.452 10.452 0 0010.452 10.448zm0-15.678a1.307 1.307 0 101.307 1.307 1.3 1.3 0 00-1.307-1.303zm0 3.92a1.3 1.3 0 00-1.307 1.306v3.92a1.307 1.307 0 002.613 0v-3.92a1.3 1.3 0 00-1.306-1.302z"
        transform="translate(-6 -6) translate(6 6) translate(-647 -344)"
        fill="#91d3f3"
        fillRule="evenodd"
      />
    </svg>
  )
}

Info.propTypes = {
  height: number,
}

export default Info
